import React from 'react';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from 'styled-components';

interface IThemeProp {
  children: React.ReactNode;
}

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    goFoward: true;
    goBack: true;
  }
}

/**
 * Theme for Material UI elements
 * @return {Theme}
 */
export const muiTheme = createTheme({
  palette: {
    primary: {
      light: '#1976D2',
      main: '#2863D0'
    },
    secondary: {
      main: '#f9c840',
      contrastText: '#4e4e4e'
    }
  },
  typography: {
    fontFamily: ['"Nunito"', 'sans-serif'].join(',')
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'goFoward' },
          style: {
            'textAlign': 'center',
            'backgroundColor': '#f9c840',
            'textTransform': 'uppercase',
            'color': '#2863d0',
            'fill': '#2863d0',
            'borderRadius': '25px',
            'fontWeight': 'bold',
            'padding': '11px 25px',
            'fontSize': '16px',
            '&:hover': {
              'backgroundColor': '#dfb134'
            }
          }
        },
        {
          props: { variant: 'goBack' },
          style: {
            'textAlign': 'center',
            'backgroundColor': 'transparent',
            'textTransform': 'uppercase',
            'color': '#f9c840',
            'borderColor': '#f9c840',
            'borderRadius': '25px',
            'border': 'solid',
            'borderWidth': '1px',
            'fontWeight': 'bold',
            'padding': '11px 25px',
            'fontSize': '16px',
            '&:hover': {
              'backgroundColor': '#fffff'
            }
          }
        }
      ]
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          'color': '#222c3f',
          'backgroundColor': '#E9EFFA',
          'border': 'none',
          '&.Mui-focused': {
            'backgroundColor': 'transparent'
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#2863d0'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& fieldset': {
            'border': 'none'
          },
          '&.Mui-focused fieldset': {
            'border': '1px solid #2863d0'
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '& span': {
            'color': '#2863d0'
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& label': {
            'color': '#2863d0'
          },
          '& p.errorMessage': {
            'color': '#d32f2f',
            'fontWeight': '400',
            'fontSize': '0.75rem',
            'lineHeight': '1.66',
            'textAlign': 'left',
            'marginTop': '3px',
            'marginRight': '14px',
            'marginBottom': '0',
            'marginLeft': '14px'
          }
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#2863D0',
          padding: '0'

        }
      }
    }
  }
});

const ConsorcieiTheme = ({ children }: IThemeProp): React.JSX.Element => (
  <ThemeProvider theme={muiTheme}>
    {children}
  </ThemeProvider>
);

export default ConsorcieiTheme;
